module.exports = __webpack_public_path__ + "img/20220518144637341pfx.07728921.jpg";